<template>
  <main class="blank-layout">
    <slot />
  </main>
</template>

<style lang="scss" scoped>
.blank-layout {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    width: 100%;
}
</style>
